import { render, staticRenderFns } from "./NoteDetail.vue?vue&type=template&id=63e8451b&scoped=true&"
import script from "./NoteDetail.vue?vue&type=script&lang=js&"
export * from "./NoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetail.vue?vue&type=style&index=0&id=63e8451b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8451b",
  null
  
)

export default component.exports